import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PageShell from '@/components/feature/PageShell';
import useHeroShutter from '@/hooks/useHeroShutter';
import { setHeroVisible } from '@/lib/shutter/hero-layer-store';
import { scrollToHomeSection } from '@/lib/home-nav';
import HeroSection from './components/HeroSection';
import SelectedWork from './components/SelectedWork';
import AboutSection from './components/AboutSection';
import ServicesSection, { RatesSection } from './components/ServicesSection';
import ClientNotes from './components/ClientNotes';
import ContactSection from './components/ContactSection';

export default function Home() {
  const { hash, key } = useLocation();
  useHeroShutter(hash);

  // Arriving from another route with /#section: jump once to the anchor (native scroll, no smoothing engine).
  useEffect(() => {
    if (!hash || hash === '#top') return;
    const id = hash.slice(1);
    setHeroVisible(false);
    // Commit route first, then scroll once layout settles; re-check after late layout (images/fonts).
    let raf2 = 0;
    const raf1 = requestAnimationFrame(() => { raf2 = requestAnimationFrame(() => scrollToHomeSection(id)); });
    const t = window.setTimeout(() => scrollToHomeSection(id), 280);
    return () => { cancelAnimationFrame(raf1); cancelAnimationFrame(raf2); window.clearTimeout(t); };
  }, [hash, key]);

  return (
    <PageShell>
      <HeroSection />
      <SelectedWork />
      <AboutSection />
      <ServicesSection />
      <ClientNotes />
      <RatesSection />
      <ContactSection />
    </PageShell>
  );
}